export default __webpack_public_path__ + "static/BPA Chatham-730a3decbdb4417ebba771fef4dd58f8.png";